module.exports = __webpack_public_path__ + "static/media/next1.7472d9b1.png";